import { StepperSelectionEvent } from "@angular/cdk/stepper";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmDialogComponent, ConfirmDialogData } from "@cotecna/dialogs";
import { Section } from "@cotecna/dynamic-view-engine";
import { InspectorsService } from "src/app/inspectors/services/inspectors.service";
import { AllInspectorsQuery } from "src/app/inspectors/services/queries/inspectors.query";
import { AddItemsToInspectionCommand } from "src/app/items/services/commands/add-items-to-inspection.command";
import { ItemsService } from "src/app/items/services/items.service";
import { ItemsLightQuery } from "src/app/items/services/queries/items.light.query";
import { AppSettings } from "src/app/settings/models/app-settings";
import { InspectorsTeamOverview } from "src/app/settings/models/inspector-team-overview";
import { Preset } from "src/app/settings/models/preset";
import { ScreenInfo } from "src/app/settings/models/screen-info";
import { AccountService } from "src/app/settings/services/account.service";
import { AppSettingsService } from "src/app/settings/services/app-settings.service";
import { PresetsService } from "src/app/settings/services/presets.service";
import {
  DynamicFormService,
  NaturalFormConverterResult,
} from "src/app/shared/services/dynamic-form/dynamic-form.service";
import { SortingService } from "src/app/shared/services/sorting/sorting.service";
import { UserRolePermissionsService } from "src/app/shared/services/user-role-permissions/user-role-permissions.service";
import { newGuid } from "src/app/shared/utils/guid-utils";

import { User } from "../../session/models/user";
import {
  ADD_SERVICE_PROVIDER_COORDINATOR_ICON,
  ADD_SERVICE_PROVIDER_COORDINATOR_LABEL,
  ADD_SERVICE_PROVIDER_COORDINATOR_NAME,
  COMDIV,
  REPORT_ISSUE_ACTION_ICON,
  REPORT_ISSUE_ACTION_LABEL,
  REPORT_ISSUE_ACTION_NAME,
} from "../constants/constants";
import { LoadingComponent } from "../dialogs/loading/loading.component";
import { ServiceProviderCoordinatorDialogComponent } from "../dialogs/service-provider-coordinator-dialog/service-provider-coordinator-dialog.component";
import { Inspection } from "../model/inspection";
import { InspectionState } from "../model/inspection-state";
import { Item } from "../model/item";
import {
  ProductsListConfig,
  ScopeOfWorkListConfig,
} from "../permissions-setter/permissions-interface";
import { PermissionsSetter } from "../permissions-setter/permissions-setter";
import { GeneralInfoService } from "../services/general-info.service";
import { InspectionFormService } from "../services/inspection-form-service/inspection-form.service";
import { PermissionsService } from "../services/permissions.service";
import { ReportIssueService } from "../services/report-issue.service";
import { EMPTY_INSPECTION } from "./empty-inspection";
import {
  SERVICE_PROVIDER_COORDINATOR_DIALOG_CONTROL,
  SERVICE_PROVIDER_COORDINATOR_DIALOG_FIELD,
} from "./forms/service-provider-dialog-form";
import { ToggleSection, ToggleSectionsForForm } from "./models/toggle-section";

@Component({
  selector: "im-new-inspection",
  templateUrl: "./new-inspection.component.html",
  styleUrls: ["./new-inspection.component.scss"],
  providers: [GeneralInfoService],
  standalone: false,
})
export class NewInspectionComponent implements OnInit, AfterViewInit {
  @ViewChild("stepper", { static: false })
  public stepper: MatStepper;

  public toolbarOptions = {
    showMenuButton: false,
    showBackButton: true,
    title: "New Inspection",
    mainActions: [],
    moreActions: [],
    showOnlyIcons: true,
    backFunction: () => {
      this.router.navigate(["/inspections"]);
    },
  };

  public isGeneralInfoReady: boolean = false;
  public inspectionNameIsCorrect: boolean = false;
  public isScopeOfWorkReady: boolean = false;
  public isItemsReady: boolean = true;
  public hasInspectorsReady: boolean = false;
  public canGetInspectorsContainer: boolean = false;
  public inspectionName: string = "";
  public isInspectionPreviouslyCreated: boolean = false;
  public selectedStepIndex: number = 0;
  public inspectionSent: boolean = false;
  public productsListConfig: ProductsListConfig;
  public scopeOfWorkConfig: ScopeOfWorkListConfig;
  public clients: string[];

  // ========= REFACTOR: USED PROPERTIES
  public inspection: Inspection;

  public presets: Preset[];
  public currentPreset: Preset;

  public toggleSowList: ToggleSection[] = [];
  public toggleItemsList: ToggleSectionsForForm[] = [];

  public allSowSections: Section[];
  public allSowControls: any[];

  public allItemForms: {
    formId: string;
    itemId: string;
    formName: string;
    controls: any[];
    sections: Section[];
  }[] = [];

  public sowScreens: ScreenInfo[] = [];

  public generalInfoLoading: boolean = false;
  public itemsLoading: boolean = false;
  //==========================================
  public isAccountTypeManagementOnly: boolean = false;

  public inspectionIsCreated: boolean;
  private serviceProviderCoordinators: User[];

  private readonly SEND_ACTION: string = "send";
  private readonly SAVE_ACTION: string = "save";

  private appSettings: AppSettings = null;

  @Output()
  public allInspectors: EventEmitter<User[]> = new EventEmitter<User[]>();

  @Output()
  public inspectorTeams: EventEmitter<InspectorsTeamOverview[]> =
    new EventEmitter<InspectorsTeamOverview[]>();

  @Output()
  public itemsFormId: string = "";

  @Output()
  public sowFormId: string = null;

  @Output()
  public alreadyAssigned: EventEmitter<string[]> = new EventEmitter<string[]>();

  public constructor(
    private inspectionFormService: InspectionFormService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private presetsService: PresetsService,
    private changeDetector: ChangeDetectorRef,
    private permissionsService: PermissionsService,
    private accountService: AccountService,
    private dynamicFormService: DynamicFormService,
    private reportIssueService: ReportIssueService,
    private appSettingsService: AppSettingsService,
    private inspectorsService: InspectorsService,
    private userRolePermissionsService: UserRolePermissionsService,
    private itemsService: ItemsService,
    private snackBarModule: MatSnackBar,
    private sortingService: SortingService,
  ) {}

  private async fillInspection(inspection: Inspection): Promise<void> {
    this.inspection.presetId = inspection.presetId;
    this.inspection.presetName = inspection.presetName;
    this.inspection.generalInfo = inspection.generalInfo;
    this.inspection.users = inspection.users;
    this.inspection.legalEntity = inspection.legalEntity;
    this.inspection.clientId = inspection.clientId;
    this.inspection.templateId = inspection.templateId;
    this.inspection.creationDate = inspection.creationDate;
    this.inspection.id = this.route.snapshot.params.id;
    this.inspection.originApplicationName = inspection.originApplicationName;
    this.inspection.externalCoordinators = inspection.externalCoordinators;
    if (inspection.timelog?.options?.length) {
      this.inspection.timelog.options = inspection.timelog.options;
    }
    // SCOPE OF WORK
    if (inspection.scopeOfWork?.form?.sections?.length) {
      this.inspection.scopeOfWork = inspection.scopeOfWork;
      this.sowFormId = inspection.scopeOfWork.formId;
      await this.getFormAndFillSowInformation(inspection.scopeOfWork.formId);
    }
    // ITEMS
    if (inspection.itemsInfo?.items?.length) {
      this.inspection.itemsInfo = inspection.itemsInfo;
      await this.setAllItemsFormInformation();
    }
  }

  public async ngOnInit(): Promise<void> {
    this.getAccountType();
    this.generalInfoLoading = true;
    this.appSettings = await this.appSettingsService.get();
    if (!this.userRolePermissionsService.isInspector())
      this.serviceProviderCoordinators =
        await this.inspectorsService.getServiceProviderCoordinators();
    this.trySetAddServiceProviderCoordinatorButton();
    this.trySetReportIssueButton();
    await this.setPermissions();
    this.presets = await this.presetsService.getPresetsList();
    this.clients = await this.accountService.getClientList();
    this.sowScreens = await this.inspectionFormService
      .getAllFormsForUserAccount()
      .toPromise();
    if (this.route.snapshot.params?.id) {
      this.isInspectionPreviouslyCreated = true;
      this.inspectionFormService
        .getInspection(this.route.snapshot.params.id)
        .subscribe({
          next: async (inspection: Inspection) => {
            this.toolbarOptions.showBackButton =
              inspection.originApplicationName == COMDIV ? false : true;
            this.inspection = JSON.parse(JSON.stringify(EMPTY_INSPECTION));
            this.validateStatus(inspection);
            await this.fillInspection(inspection);

            const preset = this.presets.find(
              (p) => p.id === inspection.presetId,
            );

            if (preset) {
              this.setPresetInfo(preset);
            }

            // TOGGLE SOW LIST
            this.updateSowToggleList();
            // TOGGLE ITEMS LIST
            this.updateItemsToggleList();
            this.updateStepCompletionState();

            this.alreadyAssigned.next(this.inspection.users);

            this.generalInfoLoading = false;
            this.changeDetector.markForCheck();
          },
          error: () => {
            this.router.navigate(["/inspections"]);
          },
        });
      this.inspectionIsCreated = true;
    } else {
      this.inspection = JSON.parse(JSON.stringify(EMPTY_INSPECTION));
      this.inspection.id = null;
      this.inspectionIsCreated = false;
      this.generalInfoLoading = false;
      this.changeDetector.markForCheck();
    }
  }

  public ngAfterViewInit(): void {
    this.stepper.selectionChange.subscribe((step: any) => {
      this.selectedStepIndex = step.selectedIndex;
    });
  }

  private getAccountType(): void {
    this.isAccountTypeManagementOnly =
      this.userRolePermissionsService.isTimeManagementOnlyAccount();
  }

  // ================== SCOPE OF WORK STEP METHODS =====================
  public async onToggleSowListChanged(toggle: ToggleSection) {
    const mainSection = this.allSowSections.find(
      (section) => section.id == toggle.id,
    );

    const modifiedToggles = this.manageGroupSectionsWhenToggleChange(
      mainSection,
      this.allSowSections,
      this.toggleSowList,
    );

    if (modifiedToggles.length > 0) {
      for (const toggle of modifiedToggles) {
        if (toggle.selected) {
          const section = this.allSowSections.find(
            (section) => section.id == toggle.id,
          );

          if (section) {
            const controls = this.allSowControls.filter((control) =>
              section.fields.some((field) => field.id === control.id),
            );

            const sectionExists =
              this.inspection.scopeOfWork.form.sections.some(
                (existingSection) => existingSection.id === section.id,
              );
            if (!sectionExists) {
              this.inspection.scopeOfWork.form.sections = [
                ...this.inspection.scopeOfWork.form.sections,
                section,
              ];
              this.inspection.scopeOfWork.form.controls = [
                ...this.inspection.scopeOfWork.form.controls,
                ...controls,
              ];
            }
          }
        } else {
          this.inspection.scopeOfWork.form.sections =
            this.inspection.scopeOfWork.form.sections.filter(
              (section) =>
                section.id !== toggle.id &&
                section.duplicated?.parentId !== toggle.id,
            );

          const remainingFieldIds = this.inspection.scopeOfWork.form.sections
            .map((section) => section.fields.map((field) => field.id))
            .reduce((acc, val) => acc.concat(val), []);

          this.inspection.scopeOfWork.form.controls =
            this.inspection.scopeOfWork.form.controls.filter((control) =>
              remainingFieldIds.includes(control.id),
            );
        }
      }
    }

    this.updateStepCompletionState();
  }

  public async onSowFormChanged(formId: string): Promise<void> {
    const form = await this.getFormAndFillSowInformation(formId);
    // Empty values
    this.dynamicFormService.setEmptyForm(
      this.inspection.scopeOfWork.form.sections,
    );
    this.inspection.scopeOfWork.values = [];
    this.sowFormId = formId;
    this.inspection.scopeOfWork = Object.assign(
      {},
      this.inspection.scopeOfWork,
    );

    // Initialize Toggle List and show selected sections
    let availableSections = [];

    if (this.currentPreset?.sowToggleList?.length > 0) {
      availableSections = form.sections.filter((section) =>
        this.currentPreset.sowToggleList.some((toggle) => toggle == section.id),
      );
    }

    // If the selected form has sections in the preset toggle list
    if (availableSections?.length > 0) {
      this.inspection.scopeOfWork.form.sections = availableSections;

      this.toggleSowList = form.sections.map(
        (section) =>
          new ToggleSection(
            section.id,
            section.name,
            this.currentPreset?.sowToggleList.some((id) => id == section.id),
          ),
      );
    }

    // If the selected form doesnt have sections in the preset toggle list -> All Selected and visible
    else {
      this.inspection.scopeOfWork.form.sections = form.sections;

      this.toggleSowList = form.sections.map(
        (section) => new ToggleSection(section.id, section.name, true),
      );
    }

    this.setSowControls();

    // UPDATE SORTING ALGORITHM
    this.inspection.scopeOfWork.form.sections.sort((a, b) =>
      this.sortingService.sortSectionsAlgorithm(
        a,
        b,
        this.inspection.scopeOfWork.form.sections,
      ),
    );
    this.toggleSowList.sort((a, b) =>
      this.sortingService.sortTogglesAlogithm(a, b, this.allSowSections),
    );
    this.updateStepCompletionState();
  }

  private async getFormAndFillSowInformation(
    formId: string,
  ): Promise<NaturalFormConverterResult> {
    // Retrieve Form
    const form = formId
      ? await this.inspectionFormService.getDynamicFormById(formId)
      : { sections: [], controls: [] };

    this.sowScreens = await this.inspectionFormService
      .getAllFormsForUserAccount()
      .toPromise();

    // Get all available sections and controls from the selectd form
    this.inspection.scopeOfWork.formId = formId == undefined ? null : formId;
    this.allSowSections = form.sections;

    //Add Form controls and controls from BE that are not in the original form (because of duplicated sections)
    this.allSowControls = [
      ...form.controls,
      ...this.inspection.scopeOfWork.form.controls.filter(
        (inspControl) =>
          !form.controls.some((control) => control.id === inspControl.id),
      ),
    ];
    this.setSowControls();
    return form;
  }

  private async updateSowToggleList() {
    this.toggleSowList = this.allSowSections.map(
      (section) =>
        new ToggleSection(
          section.id,
          section.name,
          this.inspection.scopeOfWork.form.sections.find(
            (inspectionSection) => inspectionSection.id == section.id,
          ),
        ),
    );

    // UPDATE SORTING ALGORITHM
    this.inspection.scopeOfWork.form.sections.sort((a, b) =>
      this.sortingService.sortSectionsAlgorithm(
        a,
        b,
        this.inspection.scopeOfWork.form.sections,
      ),
    );
    this.toggleSowList.sort((a, b) =>
      this.sortingService.sortTogglesAlogithm(a, b, this.allSowSections),
    );
    this.setSowControls();
  }

  // ================== ITEMS STEP METHODS =====================

  public async onItemsAdded(items: Item[]) {
    for (const item of items) {
      item.id = newGuid();
      const toggle = this.toggleItemsList.find(
        (toggle) => toggle.formId == item.formId,
      );
      if (toggle) {
        for (const section of toggle.toggleSections) {
          if (!section.selected) {
            const sectionIndex = item.form.sections.findIndex(
              (itemSection) => itemSection.id == section.id,
            );
            if (sectionIndex > -1) {
              item.form.sections.splice(sectionIndex, 1);
            }
          }
        }
      } else if (
        item.form.sections.some((section) =>
          this.currentPreset?.itemsToggleList?.includes(section.id),
        )
      ) {
        // APPLY PRESET IF NO MORE ITEMS WITH SAME FORM AND TOGGLE LIST HAS ONE OR MORE ID FROM THIS FORM
        for (let i = item.form.sections.length - 1; i >= 0; i--) {
          const section = item.form.sections[i];
          if (!this.currentPreset.itemsToggleList.includes(section.id)) {
            item.form.sections.splice(i, 1);
          }
        }
      }
    }

    this.inspection.itemsInfo.items = [
      ...this.inspection.itemsInfo.items,
      ...items,
    ];

    if (this.isInspectionPreviouslyCreated) {
      const loadingDialog = this.openLoadingDialog(
        `Inserting ${items?.length > 1 ? "items" : "item"}...`,
      ); // IF THE NEW ITEM SHARES FORM WITH ANOTHER PREVIOUS ITEM, WE SHOULD REMOVE SECTIONS NOT INCLUDED IN TOGGLES

      const command = new AddItemsToInspectionCommand(
        items,
        this.inspection.id,
      );
      const query = new ItemsLightQuery(this.inspection.id);

      Promise.all([
        await this.itemsService.invokeCommand(command),
        await this.itemsService.invokeQuery(query),
      ])
        .catch(() => {
          this.snackBarModule.open(
            "Insertion failed. Try again later.",
            "DISMISS",
          );
        })
        .finally(() => {
          loadingDialog.close();
        });
    }

    await this.updateAllItemsFormInformation();
    this.updateItemsToggleList();
    this.updateStepCompletionState();
  }

  public async onItemEdited(itemToEdit: Item) {
    const index = this.inspection.itemsInfo.items.findIndex(
      (item) => item.id === itemToEdit.id,
    );
    if (index >= 0) this.inspection.itemsInfo.items[index] = itemToEdit;
    await this.updateAllItemsFormInformation();
    this.updateItemsToggleList();
    this.updateStepCompletionState();
  }

  public async onItemDeleted(id: string) {
    const index = this.inspection.itemsInfo.items.findIndex(
      (item) => item.id === id,
    );
    if (index >= 0) this.inspection.itemsInfo.items.splice(index, 1);
    await this.updateAllItemsFormInformation();
    this.updateItemsToggleList();
    this.updateStepCompletionState();
  }

  public async onToggleItemsListChanged(formId: string, sectionId: string) {
    const toggleItemList = this.toggleItemsList.find(
      (toggle) => toggle.formId == formId,
    ).toggleSections;
    const mainToggle = toggleItemList.find(
      (section) => section.id == sectionId,
    );
    mainToggle.selected = !mainToggle.selected;

    const mainSections = this.allItemForms.find(
      (form) => form.formId == formId,
    ).sections;
    const mainSection = mainSections.find((section) => section.id == sectionId);

    const modifiedToggles = this.manageGroupSectionsWhenToggleChange(
      mainSection,
      mainSections,
      toggleItemList,
    );

    if (modifiedToggles.length > 0) {
      for (const toggle of modifiedToggles) {
        if (toggle.selected) {
          await this.addFormItemSection(formId, toggle.id);
        } else {
          await this.deleteFormItemSection(formId, toggle.id);
        }
      }
    }
  }

  private async deleteFormItemSection(
    formId: string,
    sectionId: string,
  ): Promise<void> {
    this.inspection.itemsInfo.items = this.inspection.itemsInfo.items.map(
      (newItem) => {
        if (newItem.formId === formId) {
          const sections = newItem.form.sections.filter(
            (section) =>
              section.id !== sectionId &&
              section.duplicated?.parentId !== sectionId,
          );
          return {
            ...newItem,
            form: {
              sections: sections,
              controls: newItem.form.controls.filter((control) =>
                sections.some((section) =>
                  section.fields.some((field) => field.id == control.id),
                ),
              ),
            },
          };
        }
        return newItem;
      },
    );
  }

  private async addFormItemSection(
    formId: string,
    sectionId: string,
  ): Promise<void> {
    const section = this.allItemForms
      .find((form) => form.formId == formId)
      ?.sections.find((section) => section.id == sectionId);

    if (section) {
      const controls =
        this.allItemForms
          .find((form) => form.formId == formId)
          ?.controls.filter((control) =>
            section.fields.some((field) => field.id == control.id),
          ) ?? [];

      const newItems = this.inspection.itemsInfo.items.map((newItem) => {
        if (newItem.formId == formId) {
          const sectionExists = newItem.form.sections.some(
            (existingSection) => existingSection.id === sectionId,
          );
          if (!sectionExists) {
            return {
              ...newItem,
              form: {
                sections: [...newItem.form.sections, section],
                controls: [...newItem.form.controls, ...controls],
              },
            };
          }
        }
        return newItem;
      });

      this.inspection.itemsInfo.items = [...newItems];
    }
  }

  private async updateAllItemsFormInformation(): Promise<void> {
    this.allItemForms = [];
    for (const item of this.inspection.itemsInfo.items) {
      const form = await this.inspectionFormService.getDynamicFormById(
        item.formId,
      );
      const formScreens = await this.inspectionFormService
        .getAllFormsForUserAccount()
        .pipe()
        .toPromise();
      const formName = formScreens?.find((form) => form.id == item.formId);
      this.allItemForms.push({
        formId: item.formId,
        itemId: item.id,
        formName: formName?.name ?? "",
        sections: form.sections,
        controls: form.controls,
      });
    }
  }

  private async setAllItemsFormInformation(): Promise<void> {
    this.allItemForms = [];
    for (const item of this.inspection.itemsInfo.items) {
      const form = await this.inspectionFormService.getDynamicFormById(
        item.formId,
      );
      const formScreens = await this.inspectionFormService
        .getAllFormsForUserAccount()
        .pipe()
        .toPromise();
      const formName = formScreens?.find((form) => form.id == item.formId);
      this.allItemForms.push({
        formId: item.formId,
        itemId: item.id,
        formName: formName?.name ?? "",
        sections: form.sections,
        controls: form.controls,
      });
    }
  }

  private async updateItemsToggleList() {
    this.toggleItemsList = [];
    this.allItemForms.forEach((item) => {
      if (
        !this.toggleItemsList.some((toggle) => toggle.formId == item.formId)
      ) {
        this.toggleItemsList.push(
          new ToggleSectionsForForm(
            item.formId,
            item.formName,
            item.sections.map(
              (section) =>
                new ToggleSection(
                  section.id,
                  section.name,
                  this.inspection.itemsInfo.items.some((inspectionItem) =>
                    inspectionItem.form.sections.some(
                      (inspectionItemSection) =>
                        inspectionItemSection.id == section.id,
                    ),
                  ),
                ),
            ),
          ),
        );
      }
    });

    // UPDATE SORTING ALGORITHM
    for (const item of this.inspection.itemsInfo.items) {
      item.form.sections.sort((a, b) =>
        this.sortingService.sortSectionsAlgorithm(a, b, item.form.sections),
      );
      const toggles = this.toggleItemsList.find(
        (toggle) => toggle.formId == item.formId,
      ).toggleSections;
      toggles.sort((a, b) =>
        this.sortingService.sortTogglesAlogithm(
          a,
          b,
          this.allItemForms.find((form) => form.formId == item.formId).sections,
        ),
      );
    }
  }

  private openLoadingDialog(textToDisplay: string): MatDialogRef<any> {
    return this.dialog.open(LoadingComponent, {
      data: <LoadingComponent>{
        loadingText: textToDisplay,
      },
      panelClass: "dialog",
    });
  }

  // ===========================================================

  private manageGroupSectionsWhenToggleChange(
    sectionToChange: Section,
    sections: Section[],
    toggleList: ToggleSection[],
  ): ToggleSection[] {
    const togglesEdited = [];

    // HANDLE MAIN TOGGLE
    const mainToggle = toggleList.find((item) => item.id == sectionToChange.id);
    togglesEdited.push(mainToggle);

    // HANDLE IF MAIN SECTION IS SELECTED AND HAS PARENT => SELECT ALSO THE PARENT
    if (mainToggle.selected && sectionToChange.grouping?.parentId) {
      const parentSection = sections.find(
        (section) => section.id === sectionToChange.grouping.parentId,
      );
      const toggleToAdd = toggleList.find(
        (toggle) => toggle.id == parentSection.id,
      );

      if (!toggleToAdd.selected) {
        toggleToAdd.selected = true;
        togglesEdited.push(toggleToAdd);
      }
    }
    // HANDLE IF MAIN SECTION IS DESELECTED AND HAS PARENT AND ALL THE SIBLINGS ARE UNSELECTED TOO => UNSELECT ALSO THE PARENT
    else if (!mainToggle.selected && sectionToChange.grouping?.parentId) {
      const parentSection = sections.find(
        (section) => section.id === sectionToChange.grouping.parentId,
      );
      const parentToggle = toggleList.find(
        (toggle) => toggle.id == parentSection.id,
      );

      const allSiblingsUnselected = sections
        .filter((section) => section.grouping?.parentId === parentSection.id)
        .every(
          (siblingSection) =>
            !toggleList.find((toggle) => toggle.id == siblingSection.id)
              .selected,
        );

      if (allSiblingsUnselected) {
        parentToggle.selected = false;
        togglesEdited.push(parentToggle);
      }
    }

    // HANDLE IF MAIN SECTION IS DESELECTED AND IS A PARENT => UNSELECT ALSO THE SONS
    if (!mainToggle.selected && sectionToChange.grouping?.containsGroup) {
      const sectionsToChange = sections.filter(
        (section) => section.grouping.parentId === sectionToChange.id,
      );
      for (const section of sectionsToChange) {
        const toggleToAdd = toggleList.find(
          (toggle) => toggle.id == section.id,
        );
        if (toggleToAdd.selected) {
          toggleToAdd.selected = false;
          togglesEdited.push(toggleToAdd);
        }
      }
    }

    // HANDLE IF MAIN SECTION IS SELECTED AND IS A PARENT => SELECT ALSO ALL THE SONS
    else if (mainToggle.selected && sectionToChange.grouping?.containsGroup) {
      const sectionsToChange = sections.filter(
        (section) => section.grouping.parentId === sectionToChange.id,
      );
      for (const section of sectionsToChange) {
        const toggleToAdd = toggleList.find(
          (toggle) => toggle.id == section.id,
        );
        if (!toggleToAdd.selected) {
          toggleToAdd.selected = true;
          togglesEdited.push(toggleToAdd);
        }
      }
    }

    return togglesEdited;
  }

  private setSowControls(): void {
    this.inspection.scopeOfWork.form.controls = this.allSowControls.filter(
      (control) =>
        this.inspection.scopeOfWork.form.sections.some((section) =>
          section.fields.some((field) => field.id === control.id),
        ),
    );
  }

  public async onGeneralInfoChanged(result) {
    this.isGeneralInfoReady =
      result.isValid && result.data.additionalFieldsComplete;
    if (this.inspectionName != result.data.externalId) {
      this.inspectionName = result.data.externalId;
      this.inspectionNameIsCorrect =
        this.isInspectionPreviouslyCreated ||
        !(await this.inspectionFormService
          .checkIfInspectionExists(this.inspectionName)
          .toPromise());
    }
    this.inspectionName = result.data.externalId;
    this.inspection.generalInfo = result.data;
    if (result.data.inspectionType.itemsFormId) {
      this.itemsFormId = result.data.inspectionType.itemsFormId;
    }
    this.handleInspectionDates(result.data.date);
    if (result.data.originApplicationName) {
      this.inspection.originApplicationName = result.data.originApplicationName;
    }

    if (result.data.client) {
      this.inspection.clientId = result.data.clientId;
    } else {
      this.isGeneralInfoReady = false;
    }

    try {
      this.validateDates(result.data.date);
    } catch (err) {
      this.isGeneralInfoReady = false;
      this.snackBar.open(err, "DISMISS");
    }
  }

  public validateDates(dateStrings: string[]): void {
    if (dateStrings && dateStrings.length) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const currentDay = currentDate.getDate();

      let minYear = currentYear;
      let minMonth = currentMonth - 3;
      if (minMonth < 0) {
        minYear -= 1;
        minMonth = 12 + minMonth;
      }
      const minDate = new Date(minYear, minMonth, currentDay);

      const maxDate = new Date(currentYear + 1, currentMonth, currentDay);

      for (const dateString of dateStrings) {
        const date = new Date(dateString);

        if (date < minDate || date > maxDate) {
          throw new Error(
            "Please provide a date that falls within past 3 months or up to 1 year from the current date.",
          );
        }
      }
    }
  }

  public onPresetChange(preset: Preset) {
    if (this.currentPreset != preset) {
      this.setPresetInfo(preset);
      this.inspection.presetId = preset.id;
      this.inspection.presetName = preset.name;
      this.inspection.templateId = preset.templateId;
      this.inspection.operationTypeId = preset.operationTypeId;
      this.inspection.timelog.options.splice(0);
      this.currentPreset.options.forEach((option) => {
        this.inspection.timelog.options.push(option);
      });
      this.onSowFormChanged(preset.sowFormId);
    }
  }

  private setPresetInfo(preset: Preset) {
    this.currentPreset = preset;
    this.itemsFormId = preset.itemsFormId;
  }

  public checkNameAndNext(stepper: MatStepper) {
    if (!this.inspectionNameIsCorrect) {
      this.dialog.open(ConfirmDialogComponent, {
        autoFocus: false,
        panelClass: "dialog",
        data: <ConfirmDialogData>{
          icon: "warning",
          okButton: {
            text: "ACCEPT",
            color: "primary",
          },
          cancelButton: {
            text: "",
          },
          title: "Inspection already exists",
          message: `The name ${this.inspectionName} already exists for another inspection.`,
        },
      });
    } else {
      this.canGetInspectorsContainer = true;
      stepper.next();
    }
  }

  public onItemsChanged(itemsChanged: Item[]) {
    this.inspection.itemsInfo.items = [...itemsChanged];
    this.isItemsReady = !this.hasProductWithoutSections(
      this.inspection.itemsInfo.items,
    );
    this.updateSOWNextStepButton();
  }

  public async onScopeOfWorkChanged(formId: string) {
    this.updateSOWNextStepButton();
    if (formId) {
      this.sowFormId = formId;
      this.inspection.scopeOfWork.formId = formId;
      this.sowScreens = await this.inspectionFormService
        .getAllFormsForUserAccount()
        .toPromise();
    }
  }

  public updateSOWNextStepButton() {
    if (this.isAccountTypeManagementOnly) {
      this.isScopeOfWorkReady = true;
    } else {
      this.isScopeOfWorkReady =
        this.inspection?.scopeOfWork?.form?.sections?.length > 0 ||
        this.inspection?.itemsInfo?.items?.length > 0;
    }
  }

  private updateStepCompletionState(): void {
    this.isItemsReady = !this.hasProductWithoutSections(
      this.inspection?.itemsInfo?.items ?? [],
    );
    this.updateSOWNextStepButton();
    this.changeDetector.detectChanges();
  }

  private hasProductWithoutSections(products: Item[]) {
    return products.some((p) => p.form.sections.length === 0);
  }

  public onInspectorAssigned(inspector: User) {
    if (
      inspector != null &&
      this.inspection.users.indexOf(inspector.email) == -1
    ) {
      this.inspection.users.push(inspector.email);
    }

    this.hasInspectorsReady =
      this.inspection.users != null && this.inspection.users.length > 0;
    this.alreadyAssigned.next(this.inspection.users);
  }

  public onInspectorUnassigned(inspector: User) {
    const indexOfInspectorToRemove = this.inspection.users.indexOf(
      inspector.email,
    );
    if (indexOfInspectorToRemove > -1) {
      this.inspection.users.splice(indexOfInspectorToRemove, 1);
      this.alreadyAssigned.next(this.inspection.users);
    }
  }

  public isButtonDisabled(): boolean {
    return (
      this.inspectionSent ||
      !this.isGeneralInfoReady ||
      !this.isScopeOfWorkReady
    );
  }

  public getButtonText(): string {
    return this.inspection?.generalInfo?.date?.length
      ? this.SEND_ACTION
      : this.SAVE_ACTION;
  }

  public async performAction(): Promise<any> {
    const actionMessage = this.getActionMessage();
    const action: string = this.inspectionHasDate()
      ? this.SEND_ACTION
      : this.SAVE_ACTION;
    const actionInProgress: string = this.inspectionHasDate()
      ? "Sending"
      : "Saving";
    const confirmDialog = this.openConfirmDialog(
      actionMessage,
      action.toLocaleLowerCase(),
      action,
    );
    this.emptyInspectionFormsValues();
    const result = await confirmDialog.afterClosed().toPromise();
    if (result) {
      const loadingDialog = this.openLoadingDialog(
        `${actionInProgress} inspection in progress`,
      );
      try {
        this.isInspectionPreviouslyCreated
          ? await this.updateInspection()
          : await this.postInspection();
      } catch (err) {
        this.snackBar.open(
          `It is not possible to ${action.toLocaleLowerCase()} this inspection. Try again later.`,
          "DISMISS",
        );
      } finally {
        loadingDialog.close();
      }
    }
  }

  public async onToolbarActionClicked(action: string): Promise<void> {
    switch (action) {
      case REPORT_ISSUE_ACTION_NAME:
        await this.reportIssue();
        break;
      case ADD_SERVICE_PROVIDER_COORDINATOR_NAME:
        await this.openServiceProviderCoordinatorDialog();
        break;
    }
  }

  private getActionMessage(): string {
    this.hasInspectorsReady = this.inspection.users?.length > 0;
    const message = `Are you sure that you want to ${this.inspectionHasDate() ? this.SEND_ACTION : this.SAVE_ACTION} the current inspection`;
    message + this.hasInspectorsReady ? "?" : "without inspectors yet?";
    return message;
  }

  private validateStatus(inspection: Inspection) {
    if (inspection && inspection.state != InspectionState.New) {
      this.router.navigate([`/details/${this.route.snapshot.params.id}`]);
    }
  }

  private async setPermissions() {
    const permissions: PermissionsSetter =
      await this.permissionsService.getPermissions();
    this.productsListConfig = permissions.setProductsListConfig();
    this.scopeOfWorkConfig = permissions.setScopeOfWorkConfig();
  }

  private async postInspection() {
    try {
      await this.inspectionFormService.send(this.inspection);
      this.sendingComplete();
    } catch (err) {
      console.error("postInspection", err);
      this.showErrorMessage();
    }
  }

  private async updateInspection() {
    try {
      await this.inspectionFormService.update(this.inspection);
      this.sendingComplete();
    } catch (err) {
      console.error("updateInspection", err);
      this.showErrorMessage();
    }
  }

  private sendingComplete() {
    this.inspectionSent = true;
    this.router.navigate([""]);
  }

  private showErrorMessage() {
    this.snackBar.open("There was an error trying to send the inspection", "", {
      duration: 3000,
      data: { color: "warn" },
    });
  }

  private emptyInspectionFormsValues() {
    //empty specific item form
    this.inspection.itemsInfo.items.forEach((item) => {
      this.dynamicFormService.setEmptyForm(item.form.sections);
    });
    //empty scope of work form
    this.dynamicFormService.setEmptyForm(
      this.inspection.scopeOfWork.form.sections,
    );
  }

  private openConfirmDialog(
    message: string,
    icon: string,
    action: string,
  ): MatDialogRef<any> {
    return this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      panelClass: "inspection-action-dialog",
      data: <ConfirmDialogData>{
        icon,
        okButton: {
          text: action,
          color: "primary",
        },
        title: `${action} inspection`,
        message: `${message} ${!this.hasInspectorsReady ? "without inspectors yet?" : "?"}`,
      },
    });
  }

  private inspectionHasDate(): boolean {
    return this.inspection?.generalInfo?.date?.length > 0;
  }

  private handleInspectionDates(inspectionDates: string[]) {
    if (inspectionDates?.length) {
      const dates = inspectionDates.map((date) => new Date(date));
      this.inspection.generalInfo.date = dates;
      this.inspectorsService.invokeQuery(
        new AllInspectorsQuery(
          inspectionDates?.length
            ? this.formatEarliestToYYYYMMDD(inspectionDates)
            : "",
        ),
      );
    }
  }

  private trySetReportIssueButton(): void {
    if (
      this.appSettings.ticketingReportingEnabled &&
      !this.toolbarOptions.mainActions.some(
        (x) => x.name === REPORT_ISSUE_ACTION_NAME,
      ) &&
      this.permissionsService.isCurrentUserInternal()
    )
      this.toolbarOptions.mainActions.push({
        name: REPORT_ISSUE_ACTION_NAME,
        label: REPORT_ISSUE_ACTION_LABEL,
        icon: REPORT_ISSUE_ACTION_ICON,
      });
  }

  private trySetAddServiceProviderCoordinatorButton(): void {
    if (this.serviceProviderCoordinators?.length) {
      this.toolbarOptions.mainActions.push({
        name: ADD_SERVICE_PROVIDER_COORDINATOR_NAME,
        label: ADD_SERVICE_PROVIDER_COORDINATOR_LABEL,
        icon: ADD_SERVICE_PROVIDER_COORDINATOR_ICON,
      });
    }
  }

  private async reportIssue(): Promise<void> {
    this.reportIssueService.openDialog();
  }

  private async openServiceProviderCoordinatorDialog(): Promise<void> {
    const serviceProviderCoordinatorSection = structuredClone(
      SERVICE_PROVIDER_COORDINATOR_DIALOG_FIELD,
    );
    const serviceProviderCoordinatorControl = structuredClone(
      SERVICE_PROVIDER_COORDINATOR_DIALOG_CONTROL,
    );

    this.serviceProviderCoordinators.forEach((c) => {
      serviceProviderCoordinatorControl.options.push({
        id: c.email,
        name: c.email,
      });
    });
    this.inspection.externalCoordinators.forEach((c) => {
      serviceProviderCoordinatorSection.value.push(c);
      serviceProviderCoordinatorSection.readableValue.push(c);
    });

    const dialogRef = this.dialog.open(
      ServiceProviderCoordinatorDialogComponent,
      {
        data: {
          section: serviceProviderCoordinatorSection,
          control: serviceProviderCoordinatorControl,
        },
        autoFocus: false,
        disableClose: false,
      },
    );

    const result = await dialogRef.afterClosed().toPromise();
    if (result) {
      result.data.serivceProviderCoordinators = [];
      this.inspection.externalCoordinators = [];
      result.data.serviceProviderCoordinators.forEach((c) =>
        this.inspection.externalCoordinators.push(c),
      );
    }
  }

  private formatEarliestToYYYYMMDD(dateInputs: any[]): string | null {
    if (!Array.isArray(dateInputs) || dateInputs.length === 0) return null;

    const validDates = dateInputs
      .map((d) => new Date(d))
      .filter((d) => !Number.isNaN(d.getTime()));

    if (validDates.length === 0) return null;

    const earliestDate = new Date(
      Math.min(...validDates.map((d) => d.getTime())),
    );

    const year = earliestDate.getFullYear();
    const month = String(earliestDate.getMonth() + 1).padStart(2, "0");
    const day = String(earliestDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  public onStepSelectionChange(
    event: StepperSelectionEvent,
    stepper: MatStepper,
  ) {
    if (event.previouslySelectedIndex === 0) {
      this.checkNameAndNext(stepper);
    }
  }
}
